<template lang="pug">
b-modal#modal-service-limit(title='プランのアップグレードが必要です')
  .callout.callout-info
    h5 Freeプランのため{{service_name}}作成上限は1個までになっています。
    p 有料プランでは上限なしで作成が可能です。
    a.btn.btn-primary(:href="plan_page_url") プランをアップグレード
</template>


<script>

export default {
  props: {
    plan_page_url: String,
    service_name: String,
  },
}
</script>
<style lang="scss" scoped>
</style>
